(() => {
  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgExpansionPanel', sgExpansionPanel);

  function sgExpansionPanel () {
    return {
      templateUrl: 'app-legacy/components/sg-expansion-panel/sg-expansion-panel.html',
      restrict: 'E',
      transclude: true,
      scope: {
        title: '@',
        summary: '@',
        label: '@',
        writable: '@'
      },
      controller: 'sgExpansionPanelController',
      controllerAs: 'expPnlCtrl'
    };
  }

})();
